import React from 'react';
import PropTypes from 'prop-types';
import {getStore} from 'store/store';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import SearchControls from './SearchControls';

const SearchControlsModalMobile = ({
    onHidden,
    focusSearchInput,
    datetimeOnly,
    onSearchClick,
    onClosePanelClick,
    onSuggestSelect,
    showSpotUnavailable,
    isLoading
}) => {
    return (
        <Modal
            className="SearchControlsModal"
            title="Update Search"
            onHidden={onHidden}
            store={getStore()}
        >
            <ModalContent isMobile>
                <SearchControls
                    focusSearchInput={focusSearchInput}
                    datetimeOnly={datetimeOnly}
                    onSearchClick={onSearchClick}
                    onClosePanelClick={onClosePanelClick}
                    onSuggestSelect={onSuggestSelect}
                    showSpotUnavailable={showSpotUnavailable}
                    isLoading={isLoading}
                    searchButtonText="Apply"
                />
            </ModalContent>
        </Modal>
    );
};

SearchControlsModalMobile.propTypes = {
    focusSearchInput: PropTypes.bool,
    datetimeOnly: PropTypes.bool,
    showSpotUnavailable: PropTypes.bool,
    isLoading: PropTypes.bool,
    onSearchClick: PropTypes.func,
    onClosePanelClick: PropTypes.func,
    onSuggestSelect: PropTypes.func,
    onHidden: PropTypes.func.isRequired
};

export default SearchControlsModalMobile;
